var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_document-text",
    "data-name": "vuesax/bold/document-text",
    transform: "translate(-172 -188)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.12.195A.654.654,0,0,0,0,.635v3.49a2.726,2.726,0,0,0,2.75,2.67c.95.01,2.27.01,3.4.01a.631.631,0,0,0,.47-1.07C5.18,4.285,2.6,1.675,1.12.195Z",
    transform: "translate(186.68 190.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M18,8.19H15.11a4.306,4.306,0,0,1-4.3-4.3V1a1,1,0,0,0-1-1H5.57A5.277,5.277,0,0,0,0,5.57v8.86A5.277,5.277,0,0,0,5.57,20h7.86A5.277,5.277,0,0,0,19,14.43V9.19A1,1,0,0,0,18,8.19ZM9,15.75H5a.75.75,0,0,1,0-1.5H9a.75.75,0,0,1,0,1.5Zm2-4H5a.75.75,0,0,1,0-1.5h6a.75.75,0,0,1,0,1.5Z",
    transform: "translate(174.5 190)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(196 212) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.39c374c96cc4e4a4ee873dd571501ec6.svg";
export { ForwardRef as ReactComponent };